import { render } from "./QuizTest.vue?vue&type=template&id=472ae522&ts=true"
import script from "./QuizTest.vue?vue&type=script&lang=ts"
export * from "./QuizTest.vue?vue&type=script&lang=ts"

import "./QuizTest.vue?vue&type=style&index=0&id=472ae522&lang=scss"

import exportComponent from "C:\\Users\\artur\\Documents\\CODELEX\\2 - CODELEX\\JOB SEARCH\\COMPANY ASSIGNMENTS\\Printful\\frontend-quiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__